import XYZColor from '../classes/xyz-color';
import sRGBAssume from '../helpers/srgb-assume';

const rgb2xyz = ({ red, green, blue }) => {
  const r = sRGBAssume(red);
  const g = sRGBAssume(green);
  const b = sRGBAssume(blue);

  const x = 0.4124564 * r + 0.3575761 * g + 0.1804375 * b;
  const y = 0.2126729 * r + 0.7151522 * g + 0.072175 * b;
  const z = 0.0193339 * r + 0.119192 * g + 0.9503041 * b;

  return new XYZColor(x, y, z);
};

export default rgb2xyz;
